import { Component, OnInit, NgZone, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { QuestionServiceService } from '../../../../services/question-service.service';
import { FeeColumnFilterPanelService } from '../../../../services/fee-column-filter-panel.service';
import { AlertService } from '../../../../services';

@Component({
  selector: 'app-tryout-read-questions',
  templateUrl: './tryout-read-questions.component.html',
  styleUrls: ['./tryout-read-questions.component.css']
})
export class TryoutReadQuestionsComponent implements OnInit {
  @Output() getQuestionDetailsEvent = new EventEmitter();

  public isFirstVisit = true;
  public routeParams;
  public popupConfirmForm: FormGroup;
  public isOpenConfirmDeletePopup = false;
  public loadingIndicator = true;

  public NoOfTotalQuestions?: number;
  public NoOfTotalRequiredQuestions?: number;
  public NoOfTotalNotRequiredQuestions?: number;

  public StandardQuestions? = [];
  public CustomQuestions? = [];
  public selectedRecordIndex? = [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;
  public NoOfSelectedQuestion: number;
  public standardQuestionTabHeader: string;

  // Confirm Window
  public confirmForm: FormGroup;

  public isOpenConfirmCorrectPopup = false;
  public isConfirmWarning = false;
  public alphaNumericPattern: RegExp;
  public warningMessage: string;
  public validationMessages = {};
  public Title: string;
  public SubTitle: string;

  public isAddQuestion = false;
  public isEditQuestion = false;
  public customQuestionTabHeader: string;
  public QuestionId: number;
  public IsInUse: number;
  public isStandardQuestionsTabActive = false;
  public isCustomQuestionsTabActive = false;
  public isShowAddCustomForm = true;
  updateQuestionSub: any;

  constructor(private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private questionService: QuestionServiceService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private alertService: AlertService) {

    // Confirm Window
    this.Title = 'Delete Question';
    this.SubTitle = 'By deleting the question or questions you will be deleting it from all players. Type "DELETE" in all caps to confirm deletion.';
    this.alphaNumericPattern = /^[a-zA-Z ]+$/;
    this.warningMessage = 'The confirm text does not match.';
    this.validationMessages = {
      'Required': 'This field is required.',
      'Pattern': 'Only characters valid in this field.',
    };
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;

    this.getQuestionCounter();
    if (this.routeParams.isRequired === 'all') {
      this.getQuestions(0);
    } else if (this.routeParams.isRequired === 'required') {
      this.getQuestions(1);
    } else if (this.routeParams.isRequired === 'notrequired') {
      this.getQuestions(2);
    }

    /* Fixed: same page refresh content. (tempory archive) */
    this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
      return false;
    };

    this.initConfirmForm();
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }

  refreshReocrds(event) {
    console.log("refreshReocrds:", event);
    this.getQuestionCounter();
    this.getQuestions(event.IsRequired);
    this.isSelectAllCheckBox = false;
    this.isCheckAllCheckBox = false;
  }

  getQuestionCounter() {
    this.questionService.getCustomQuestionCounts(this.routeParams.id).subscribe(rs => {
      this.NoOfTotalQuestions = rs[0].totalCustomQuestions;
      this.NoOfTotalRequiredQuestions = rs[0].requiredCustomQuestions;
      this.NoOfTotalNotRequiredQuestions = rs[0].notRequiredCustomQuestions;
    });
  }

  getQuestions(status) {
    console.log("status:", status);

    this.spinnerService.show();
    this.questionService.getQuestions(this.routeParams.id, status).subscribe(rs => {

      this.StandardQuestions = rs.standardQuestionList ? rs.standardQuestionList.filter(x => !x.isParent) : rs.standardQuestionList;
      this.CustomQuestions = rs.customQuestionList;

      console.log("this.CustomQuestions:", this.CustomQuestions);

      /* Page navigation */
      if (this.isFirstVisit) {
        this.isFirstVisit = false;
        this.spinnerService.hide();
      } else {
        const RP = this.routeParams;
        if ((Number(status) === 0 || status === '0') && (RP.isRequired !== 'all')) {
          this.router.navigateByUrl('tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/question/all');
        } else if ((Number(status) === 1 || status === '1') && (RP.isRequired !== 'required')) {
          this.router.navigateByUrl('tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/question/required');
        } else if ((Number(status) === 2 || status === '2') && (RP.isRequired !== 'notrequired')) {
          this.router.navigateByUrl('tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/question/notrequired');
        } else {
          this.spinnerService.hide();
        }
      }
    });
  }

  selectAll() {
    if (this.isSelectAllCheckBox) {
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
      this.selectedRecordIndex.length = 0;
    } else {
      this.isSelectAllCheckBox = true;
      this.isCheckAllCheckBox = true;
      const l = this.CustomQuestions.length;
      for (let i = 0; i < l; i++) {
        this.selectedRecordIndex.push(this.CustomQuestions[i].clubprogramquestionID);
      }
    }
    // For enable status/delete button.
    this.NoOfSelectedQuestion = this.selectedRecordIndex.length;
  }

  selectedRecord(i, e) {
    if (e.target.checked) {
      this.selectedRecordIndex.push(i);
    } else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(i), 1);
    }
    // For enable status/delete button.
    this.NoOfSelectedQuestion = this.selectedRecordIndex.length;
  }

  deleteSelectedQuestions(id) {

    var isQuestionInUse = false;

    this.CustomQuestions.forEach(element => {
      if (this.selectedRecordIndex.filter(x => x == element.clubprogramquestionID && element.isInUse).length > 0) {
        isQuestionInUse = true;
      }
    });

    if (isQuestionInUse) {
      if (this.selectedRecordIndex.length == 1) {
        this.alertService.warn("Selected question cannot be deleted as it is in use.");
      }
      else {
        this.alertService.warn("Cannot be deleted question(s) as one of the selected question is in use.");
      }
    }
    else {
      //this.selectedRecordIndex.push(id);
      this.openPopup();
    }
  }

  editStandardQuestion(clubprogramquestionID, event) {

    this.isStandardQuestionsTabActive = true;
    this.isCustomQuestionsTabActive = false;
    this.isShowAddCustomForm = false;
    this.standardQuestionTabHeader = 'Edit Standard Question';
    this.QuestionId = clubprogramquestionID; // Pass id to edit question component
    this.openSideOverlay();
  }

  /* ============================== Confirm Window ============================== */
  initConfirmForm() {
    this.confirmForm = this.fb.group({
      txtConfirmText: [null]
    });
  }
  isConfirmTextMatched(confirmWithText) {
    const val = this.confirmForm.get('txtConfirmText').value;
    if (val) {
      return (val.trim() === confirmWithText) ? true : false;
    }
  }
  isConfirmTextValid() {
    return this.confirmForm.get('txtConfirmText').errors
      && (this.confirmForm.get('txtConfirmText').touched
        || this.confirmForm.get('txtConfirmText').dirty);
  }
  validateUi() {
    Object.keys(this.confirmForm.controls).forEach(field => {
      const control = this.confirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  addConfirmFormValidation() {
    const control = this.confirmForm.get('txtConfirmText');
    control.setValidators(Validators.compose([Validators.required, Validators.pattern(this.alphaNumericPattern)]));
    control.updateValueAndValidity();
  }
  removeConfirmFormValidation() {
    const control = this.confirmForm.get('txtConfirmText');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  openPopup() {
    this.isOpenConfirmCorrectPopup = true;
    this.addConfirmFormValidation();
  }
  closePopup() {
    this.isOpenConfirmCorrectPopup = false;
    this.isConfirmWarning = false;
    this.confirmForm.reset();
    this.removeConfirmFormValidation();
  }
  onPopUpConfirm(event, formValue, confirmWithText) {
    event.stopPropagation();
    const flag = this.isConfirmTextMatched(confirmWithText);
    if (flag) {
      event.target.innerHTML = 'Deleting <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;

      const l = this.selectedRecordIndex.length;
      const ids = this.selectedRecordIndex.filter(x => !!x).join(',');

      /* Delete selected questions. */
      this.questionService.deleteMultipleQuestionsByIDs(ids).subscribe((data) => {
        event.target.innerHTML = 'Confirm';
        this.closePopup();

        //this.refreshReocrds();
        this.getQuestionCounter();

        this.getQuestions(0);
        // if (this.routeParams.isRequired === 'all') {
        //   this.getQuestions(0);
        // } else if (this.routeParams.isRequired === 'required') {
        //   this.getQuestions(1);
        // } else if (this.routeParams.isRequired === 'notrequired') {
        //   this.getQuestions(2);
        // }

        //this.getQuestions(this.routeParams.isRequired);

        this.isSelectAllCheckBox = false;
        this.isCheckAllCheckBox = false;
        this.NoOfSelectedQuestion = 0;
        this.selectedRecordIndex.length = 0;

        if (l === 1) {
          this.alertMessage('success', 'A Question successfully deleted.');
        } else {
          this.alertMessage('success', 'Questions successfully deleted.');
        }
      }, error => {
        console.log(error);
      });
    } else {
      this.isConfirmWarning = true;
    }
  }
  /* ============================== END Confirm Window ============================== */



  /* ============================== FLYOUT MENU (QUESTIONS) ============================== */
  openSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(true);
  }

  closeSideOverlay() {
    this.isAddQuestion = true;
    this.isEditQuestion = false;
    this.isStandardQuestionsTabActive = false;
    this.isCustomQuestionsTabActive = false;
    this.isShowAddCustomForm = true;
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }
  newQuestion() {
    this.isAddQuestion = true;
    this.isEditQuestion = false;
    this.isStandardQuestionsTabActive = false;
    this.isCustomQuestionsTabActive = false;
    this.isShowAddCustomForm = true;
    this.customQuestionTabHeader = 'Create Custom Question';
    this.openSideOverlay();
  }
  editQuestion(item, event) {
    event.stopPropagation();

    //console.log("item =>", item);

    this.isAddQuestion = false;
    this.isEditQuestion = true;
    this.isStandardQuestionsTabActive = false;
    this.isCustomQuestionsTabActive = true;
    this.isShowAddCustomForm = false;
    this.customQuestionTabHeader = 'Edit Custom Question';
    this.QuestionId = item.clubprogramquestionID; // Pass id to edit question component
    this.IsInUse = item.isInUse;
    this.openSideOverlay();
  }
  /* ============================== END FLYOUT MENU (QUESTIONS) ============================== */

  onCustomQuestionOrderChange() {
    if (this.updateQuestionSub) {
      this.updateQuestionSub.unsubscribe();
    }
    this.updateQuestionSub = this.questionService.updateQuestionsOrder(this.routeParams.id, this.CustomQuestions.map((q, index) => ({
      clubprogramQuestionID: q.clubprogramquestionID,
      order: index
    }))).subscribe(() => { });
  }

  onStandardQuestionOrderChange() {
    if (this.updateQuestionSub) {
      this.updateQuestionSub.unsubscribe();
    }
    this.updateQuestionSub = this.questionService.updateQuestionsOrder(this.routeParams.id, this.StandardQuestions.map((q, index) => ({
      clubprogramQuestionID: q.clubprogramquestionID,
      order: index
    }))).subscribe(() => { });
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-questions/tryout-read-questions/tryout-read-questions.component.ts